export default __webpack_public_path__ + "static/media/TEL.78ec50ff.png";